import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'data',
    collectionActionName: 'SLOT_GROUPS',
    itemActionName: 'SLOT_GROUP',
});
